import { render, staticRenderFns } from "./doc.vue?vue&type=template&id=f5008a3e&"
import script from "./doc.vue?vue&type=script&lang=ts&"
export * from "./doc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "doc.vue"
export default component.exports